namespace Nobox.Master {
    export interface ChannelForm {
        Nm: Serenity.StringEditor;
        Kd: Serenity.StringEditor;
        Kt: AccountCategoryEditor;
        St: Serenity.BooleanEditor;
        Pg: Serenity.IntegerEditor;
        Sym: Serenity.IntegerEditor;
        CountryId: Serenity.ServiceLookupEditor;
        Url: Serenity.StringEditor;
        VersionName: Serenity.StringEditor;
        VersionDate: CustomDatePickerEditor;
        Ket: Serenity.StringEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
    }

    export class ChannelForm extends Serenity.PrefixedContext {
        static formKey = 'Master.Channel';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ChannelForm.init)  {
                ChannelForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = AccountCategoryEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = CustomDatePickerEditor;
                var w6 = CustomDateTimeEditor;

                Q.initFormType(ChannelForm, [
                    'Nm', w0,
                    'Kd', w0,
                    'Kt', w1,
                    'St', w2,
                    'Pg', w3,
                    'Sym', w3,
                    'CountryId', w4,
                    'Url', w0,
                    'VersionName', w0,
                    'VersionDate', w5,
                    'Ket', w0,
                    'In', w6,
                    'Up', w6
                ]);
            }
        }
    }
}
